import { useTranslation } from 'react-i18next';

import { DataPanel } from '@/ui';
import type { Caller, Location } from '@/signalr';
import { CallerLocationBlock } from './CallerLocationBlock';

export type CallerLocationSectionProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  callerPosition: Location | null;
  callerPositionHistory: readonly Location[];
  caller: Caller;
  chatIsActive: boolean;
};

export function CallerLocationSection({
  incidentId,
  incidentIsReadOnly,
  callerPosition,
  callerPositionHistory,
  caller,
  chatIsActive,
}: CallerLocationSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_CallerLocationHeader')} testID="incident-caller-location-panel">
      <CallerLocationBlock
        incidentId={incidentId}
        incidentIsReadOnly={incidentIsReadOnly}
        callerPosition={callerPosition}
        callerPositionHistory={callerPositionHistory}
        caller={caller}
        chatIsActive={chatIsActive}
      />
    </DataPanel>
  );
}
